import type { RoleName } from '@/types/role'

export const ROLE_LABELS: Record<RoleName, string> = {
  admin: 'Administrador',
  manager: 'Gestor',
  instructor: 'Professor',
  operator: 'Operador',
  student: 'Aluno',
}
